export default __webpack_public_path__ + "static/media/ConfeteBG.4a8093de.png";